import React from 'react';

import './ResetNewsieButton.css'

const ResetNewsieButton = (props) => {
  const { onClickReset, completedLoserDiscovery} = props
  const className = `reset-newsie-button ${completedLoserDiscovery ? '': 'disabled'}`
  return (<div className='reset-newsie-button-container'>
    <button className={className} onClick={onClickReset}>
      Try Again
    </button>
  </div>)
};

export default ResetNewsieButton;